// extracted by mini-css-extract-plugin
export default {"modal":"reportBugModal_modal__ygxEq","title":"reportBugModal_title__0-nYX","description":"reportBugModal_description__qlOu3","btn":"reportBugModal_btn__h5hh9"};